import { render, staticRenderFns } from "./VacationRequestDetails.vue?vue&type=template&id=0d8a71ae&scoped=true&"
import script from "./VacationRequestDetails.vue?vue&type=script&lang=ts&"
export * from "./VacationRequestDetails.vue?vue&type=script&lang=ts&"
import style0 from "./VacationRequestDetails.vue?vue&type=style&index=0&id=0d8a71ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a71ae",
  null
  
)

export default component.exports